module.exports = __webpack_public_path__ + "img/modal-registro.384c4d04.png";